<template src="./AccountInformationAndBalances.html"></template>

<script>
import mixins from "../../../../Mixins.js";
import WholeMultiselect from "@/components/whole-multiselect/WholeMultiselect.vue";
export default {
  mixins: [mixins],
  components: { WholeMultiselect },
  data() {
    return {
      month:  null,
      year: null,
      years: [],
      disabledSelectYear: true,
      months: [
        { value: 1, text: "Janeiro" },
        { value: 2, text: "Fevereiro" },
        { value: 3, text: "Março" },
        { value: 4, text: "Abril" },
        { value: 5, text: "Maio" },
        { value: 6, text: "Junho" },
        { value: 7, text: "Julho" },
        { value: 8, text: "Agosto" },
        { value: 9, text: "Setembro" },
        { value: 10, text: "Outubro" },
        { value: 11, text: "Novembro" },
        { value: 12, text: "Dezembro" }
      ],
      netBalance: 0,
      totalInactivated: 0,
      totalAccountMaster: 0,
      totalBlockAndFiloo: 0,
      totalBalanceBlockFiloo: 0,
      totalBalanceClient: 0,
      totalBalanceDoctor: 0,
      historic: [],
      conciliationBalance: [],
      radialBarChart: {
        series: [0, 0, 0, 0],
        chartOptions: {
          colors: ["#F06428", "#147877", "#508cc8", "#3c6997"],
          plotOptions: {
            radialBar: {
              dataLabels: {
                name: {
                  fontSize: "14px"
                },
                value: {
                  fontSize: "14px"
                },
                total: {
                  show: true,
                  label: "Conta Master",
                  formatter: function() {
                    var total = 100;
                    return total + "%";
                  }
                }
              }
            }
          },
          labels: [
            "Saldo líquido",
            "Saldo clientes",
            "Saldo profissionais",
            "Saldo inativos"
          ]
        }
      },
      options: {
        legend: {
          position: "bottom",
          horizontalAlign: "left",
          itemMargin: {
            horizontal: 60,
            vertical: 0
          },
        },
        colors: ["#FF0000", "#508cc8", "#3c6997", "#78c8be"],
        labels: [
          "Saldo inativos",
          "Saldo profissionais",
          "Saldo clientes",
          "Saldo líquido"
        ]
      },
      series: [0, 0, 0, 0],
      invalidFields: {
        year: false,
        month: false
      }
    };
  },
  mounted: function() {
    const vm = this;
    vm.init();
  },
  watch: {
    year: function () {
      const vm = this;
      vm.changeYear();
      if(vm.testNullUndefinedEmpty(vm.year)) {
        vm.month = null;
      }
    }
  },
  methods: {
    init() {
      const vm = this;
      vm.getTransactions();
      vm.fillYears();
    },
    fillYears() {
      const vm = this;
      let year = 2019;
      vm.year = year;
      
      for (let i = 0; i < 32; i++) {
        vm.years.push(year++);
      }
      vm.year = new Date().getFullYear();
      vm.month = vm.months.find(m => m.value === new Date().getMonth()+1);
    },

    changeYear() {
      const vm = this;
      if(vm.year === 2019) {
        vm.months = 
          [
            { value: 10, text: "Outubro" },
            { value: 11, text: "Novembro" },
            { value: 12, text: "Dezembro" }
        ]
        if(!vm.testNullUndefinedEmpty(vm.month) && vm.month.value < 10) {
          vm.month = vm.months[0];
        }
      } else {
        vm.months = vm.year === "" ? [] : 
          [
            { value: 1, text: "Janeiro" },
            { value: 2, text: "Fevereiro" },
            { value: 3, text: "Março" },
            { value: 4, text: "Abril" },
            { value: 5, text: "Maio" },
            { value: 6, text: "Junho" },
            { value: 7, text: "Julho" },
            { value: 8, text: "Agosto" },
            { value: 9, text: "Setembro" },
            { value: 10, text: "Outubro" },
            { value: 11, text: "Novembro" },
            { value: 12, text: "Dezembro" }
          ]
      }
    },

    updateChart() {
      const vm = this;
      vm.series = [
        vm.round(vm.totalInactivated, 2),
        vm.round(vm.totalBalanceDoctor, 2),
        vm.round(vm.totalBalanceClient, 2),
        vm.round(vm.netBalance, 2)
      ];

      var percentBalanceDoctor =
        (vm.totalBalanceDoctor * 100) / vm.totalAccountMaster;
      var percentBalanceClient =
        (vm.totalBalanceClient * 100) / vm.totalAccountMaster;
      var percentInactivated =
        (vm.totalInactivated * 100) / vm.totalAccountMaster;
      var percentNetBalance = (vm.netBalance * 100) / vm.totalAccountMaster;
      vm.radialBarChart.series = [
        vm.round(percentNetBalance, 2),
        vm.round(percentBalanceClient, 2),
        vm.round(percentBalanceDoctor, 2),
        vm.round(percentInactivated, 2)
      ];
      vm.$vs.loading.close();
    },
    
    getTransactions() {
      const vm = this;
      vm.$vs.loading();
      var bearer = vm.$session.get("bearer");

      const filter = (!vm.testNullUndefinedEmpty(vm.year) && !vm.testNullUndefinedEmpty(vm.month)) ?
        `?year=${vm.year}&month=${vm.month.value}` : "";

      vm.axios
        .get(vm.$store.state.filooServer + "payment/get-account-information-and-balances" + filter, {
          headers: { Authorization: bearer }
        })
        .then(function(response) {
          if (response.status === 200) {
            vm.totalAccountMaster = response.data.totalAccountMaster;
            vm.totalBalanceBlockFiloo = response.data.totalBalanceBlockFiloo;
            vm.totalBalanceClient= response.data.totalBalanceClient;
            vm.totalBalanceDoctor= response.data.totalBalanceDoctor;
            vm.totalInactivated= response.data.totalInactivated;
            vm.netBalance= response.data.netBalance;
            vm.updateChart();
          }
        }).catch(()=> {
          vm.showErrorMessage();
        });
    },

    clearSearch() {
      const vm = this;
      vm.year = null;
      vm.month = null;
    },

    searchByDate() {
      const vm = this;
      vm.invalidFields.year = vm.testNullUndefinedEmpty(vm.year) && !vm.testNullUndefinedEmpty(vm.month);
      vm.invalidFields.month = !vm.testNullUndefinedEmpty(vm.year) && vm.testNullUndefinedEmpty(vm.month);
      
      if(!vm.invalidFields.year && !vm.invalidFields.month) {
        vm.getTransactions();
      }
    },

    showErrorMessage() {
      const vm = this;
      vm.$vs.loading.close();
      vm.$vs.notify({
        title: "Erro",
        text:
          "Não foi possível obter as informações, atualize a página para tentar novamente.",
        color: "warning",
        icon: "error",
        time: 6000,
        position: "top-right"
      });
    }
  }
};
</script>

<style lang="scss" src="./AccountInformationAndBalances.scss">
</style>